import {
    createCurrencyFormatter,
    createInternalLinkFormatter,
    DataTableColumn,
} from '@/components/ui/data-table-customized'
import { TFunction } from 'i18next'
import { RevenueCombinedByCustomer } from '../../types'

export const getCustomerGroupColumns = (
    t: TFunction<'translation'>
): DataTableColumn<RevenueCombinedByCustomer>[] => [
    {
        key: 'customer_name',
        title: t('customer_name', { defaultValue: 'Khách hàng' }),
        width: 350,
        cellClassName: 'truncate',
        formatter: createInternalLinkFormatter({
            pathKey: 'customerDetail',
            pathParams: (_, row) => ({
                id: row.customer_id.toString(),
            }),
            label: (_, row) => `${row.customer_id} - ${row.customer_name}`,
        }),
    },
    {
        key: 'record_count',
        title: t('record_count', { defaultValue: 'Số bản ghi' }),
        width: 120,
        headerClassName: 'text-right',
        cellClassName: 'text-right',
        render: (value) => (
            <span className="text-xs text-gray-600">{value}</span>
        ),
    },
    {
        key: 'total_amount',
        title: t('total_amount', { defaultValue: 'Tổng doanh thu' }),
        width: 180,
        headerClassName: 'text-right',
        cellClassName: 'text-right',
        formatter: createCurrencyFormatter({
            currency: '',
        }),
    },
]
